var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M4.927 6.709 3.03 7.927a.6.6 0 0 1-.9-.67l.599-2.097L.994 3.822a.6.6 0 0 1 .34-1.075l2.234-.094.8-2.074a.6.6 0 0 1 1.12 0l.799 2.074 2.233.094a.6.6 0 0 1 .341 1.075L7.127 5.16l.6 2.097a.6.6 0 0 1-.901.67z",
    clipRule: "evenodd"
  })));
};
export default SvgStarFilled;